import * as routes from '@/constants/routes';
import * as subjects from '@/constants/subjects';
import * as actions from '@/constants/actions';
import * as entityStatuses from '@/constants/entityStatuses';
import { canAbility } from './middleware';

export default {
  path: '/services',
  name: routes.SERVICES_PARENT,
  component: { render: h => h('router-view') },
  redirect: { name: routes.SERVICES },
  children: [
    {
      path: '/services',
      name: routes.SERVICES,
      component: () => import('@/views/Services/index.vue'),
      meta: {
        middleware: [canAbility([actions.READ], subjects.SERVICES)],
      },
      props: route => ({ status: entityStatuses.ACTIVE, page: Number(route.query.page) || 1 }),
    },
    {
      path: '/services/archive',
      name: routes.SERVICES_ARCHIVE,
      component: () => import('@/views/Services/index.vue'),
      meta: {
        middleware: [canAbility([actions.READ], subjects.SERVICES)],
      },
      props: route => ({ status: entityStatuses.ARCHIVED, page: Number(route.query.page) || 1 }),
    },
    {
      path: '/services/create',
      name: routes.SERVICES_CREATE,
      component: () => import('@/views/Services/Modify.vue'),
      meta: {
        middleware: [canAbility([actions.UPDATE], subjects.SERVICES)],
      },
      props: route => ({
        isEdit: false,
        category: +route.query?.category || null,
        categoryName: route.query?.categoryName,
        prevPage: +route.query?.prevPage || 1,
      }),
    },
    {
      path: '/services/category/create',
      name: routes.SERVICES_CATEGORY_CREATE,
      component: () => import('@/views/Services/ModifyCategory.vue'),
      meta: {
        middleware: [canAbility([actions.UPDATE], subjects.SERVICES)],
      },
      props: route => ({
        isEdit: false,
        prevPage: +route.query?.prevPage || 1,
      }),
    },
    {
      path: '/services/:id',
      name: routes.SERVICES_DETAILED,
      component: () => import('@/views/Services/Detailed.vue'),
      meta: {
        middleware: [canAbility([actions.READ], subjects.SERVICES)],
      },
      props: route => ({ id: +route.params.id, prevPage: +route.query.prevPage || 1 }),
    },
    {
      path: '/services/:id/edit',
      name: routes.SERVICES_EDIT,
      component: () => import('@/views/Services/Modify.vue'),
      meta: {
        middleware: [canAbility([actions.UPDATE], subjects.SERVICES)],
      },
      props: route => ({ isEdit: true, id: +route.params.id, prevPage: +route.query?.prevPage || 1 }),
    },
    {
      path: '/services/category/:id/edit',
      name: routes.SERVICES_CATEGORY_EDIT,
      component: () => import('@/views/Services/ModifyCategory.vue'),
      meta: {
        middleware: [canAbility([actions.UPDATE], subjects.SERVICES)],
      },
      props: route => ({ isEdit: true, id: +route.params.id, prevPage: +route.query?.prevPage || 1 }),
    },
  ],
};
